<!-- template for the modal component -->
<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      v-if="applicationData.Application === undefined"
      align-center
      justify-center
      row
      fill-height>
      <v-progress-circular
        :size="70"
        :width="7"
        indeterminate
        color="primary"
      />
    </v-layout>
    <v-layout
      v-if="applicationData.Application !== undefined"
      justify-left
      wrap>
      <application-detail-info
        :application-data="applicationData"
        :processing-approve-application-request="processingApproveApplicationRequest"
        :processing-cancel-application-request="processingCancelApplicationRequest"
        @approveApplicationOffer="approveApplicationOffer"
        @cancelApplicationOffer="cancelApplicationOffer"/>
      <v-flex md12>
        <h3 class="heading-4">{{ 'krita.application.claimsinapp' | translate }}</h3>
        <br >
        <v-card>
          <search-text-field
            :search-phrase="applicationSearch"
            :row-count="claimRowCount"
            @search="applicationSearchRefresh"
          />
          <application-detail-datagrid
            :application-status="applicationData.Application.Status"
            :claims="claims"
            :rows-per-page="claimsRowsPerPage"
            :loading-claims="loadingClaims"
            :processing-remove-claim-from-application-request="processingRemoveClaimFromApplicationRequest"
            @removesFactoringFromApplication="removesFactoringFromApplication"
            @refreshWithSort="refreshClaimsWithSort"
          />
          <div class="text-xs-center pt-2">
            <pagination
              :selected-page="selectedClaimsPage"
              :rows-per-page="claimsRowsPerPage"
              :row-count="claimRowCount"
              @changeDisplayedRowCount="claimChangeDisplayedRowCount"
              @clickedPage="changeClaimsPage"/>
          </div>
        </v-card>
      </v-flex>

      <v-flex 
        v-if="showRefactorings" 
        md12>
        <h3 class="heading-4">{{ 'krita.application.refactored' | translate }}</h3>
        <br >
        <v-card>
          <application-detail-refactorings-datagrid
            :items="refactorings"
            :rows-per-page="refactoringsRowsPerPage"
            :loading="refactoringLoading"
            :total-items="refactoringRowCount"
            @refreshWithSort="refreshRefactoringsWithSort"
          />
          <div class="text-xs-center pt-2">
            <pagination
              :selected-page="selectedReactoringsPage"
              :rows-per-page="refactoringsRowsPerPage"
              :row-count="refactoringRowCount"
              @changeDisplayedRowCount="refactoringsChangeDisplayedRowCount"
              @clickedPage="changeRefactoringsPage"/>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
import ApplicationDetailRefactoringsDatagrid from'./applicationDetail/ApplicationDetailRefactoringsDatagrid';
import ApplicationDetailDatagrid from'./applicationDetail/ApplicationDetailDatagrid';
import ApplicationDetailInfo from'./applicationDetail/ApplicationDetailInfo';
import Pagination from './controllers/Pagination.vue';
import SearchTextField from './controllers/SearchTextField';
	export default {
	    components: {Pagination, ApplicationDetailInfo, ApplicationDetailDatagrid, SearchTextField, ApplicationDetailRefactoringsDatagrid},
        props: ['id'],
        data: () => ({
          claimsPagination: {},
          selectedClaimsPage: 1,
          claimsRowsPerPage: 5,
          claims: [],
          loadingClaims: false,
          claimsSorting: {},
          applicationSearch: '',
          claimRowCount: 0,

          refactoringsPagination: {},
          selectedReactoringsPage: 1,
          refactoringsRowsPerPage: 5,
          refactorings: [],
          refactoringLoading: false,
          refactoringSorting: {},
          refactoringRowCount: 0,

          showRefactorings: false,

          applicationData: {},

          processingRemoveClaimFromApplicationRequest: false,
          processingApproveApplicationRequest: false,
          processingCancelApplicationRequest: false,
        }),
	    computed: {
	      ...mapState({
                UserInfo: state => state.user.userInfo
            }),
        },
        mounted () {
	      let self = this;

	      self.refreshPage();
        },
        methods: {
          //refactorings grid
	      changeClaimsPage (page)
          {
            let self = this;

            self.selectedClaimsPage = page;
            self.refreshClaimsData()
          },

          claimChangeDisplayedRowCount (rowCount)
          {
            let self = this;

            self.selectedClaimsPage = 1;
            self.claimsRowsPerPage = isNaN(parseInt(rowCount))? -1 : parseInt(rowCount);
            self.refreshClaimsData();
          },

          refreshClaimsWithSort (pagination)
          {
            let self = this;

            self.claimsSorting = {};
            self.claimsSorting[pagination.sortBy] = pagination.descending ? 'desc' : 'asc';
            self.refreshClaimsData ();
          },

          applicationSearchRefresh (search)
          {
            let self = this;

            if (search !== '')
            {
              self.selectedClaimsPage = 1
            }
            self.applicationSearch = search;
            self.refreshClaimsData();
          },

          //refactorings grid
          changeRefactoringsPage (page)
          {
            let self = this;

            self.selectedReactoringsPage = page;
            self.refreshRefactoringsData()
          },

          refactoringsChangeDisplayedRowCount (rowCount)
          {
            let self = this;

            self.selectedReactoringsPage = 1;
            self.refactoringsRowsPerPage = isNaN(parseInt(rowCount))? -1 : parseInt(rowCount);
            self.refreshRefactoringsData();
          },

          refreshRefactoringsWithSort (pagination)
          {
            let self = this;

            self.refactoringSorting = {};
            self.refactoringSorting[pagination.sortBy] = pagination.descending ? 'desc' : 'asc';
            self.refreshRefactoringsData ();
          },

          refreshClaimsData ()
          {
            let self = this;

            self.loadingClaims = true;
            let claimsFetch = self.$store.dispatch('applications/getApplicationClaims',  {id: self.id, page:self.selectedClaimsPage, rowCount: self.claimsRowsPerPage, pagination: self.claimsPagination, sort: self.claimsSorting, search: self.applicationSearch });
            claimsFetch.then(response =>
            {
              self.processClaimsData(response);
              self.loadingClaims = false;
            }, () =>
                    {
                      // error
                      self.loadingClaims = false;
                    }
            );
          },
          refreshRefactoringsData ()
          {
            let self = this;

            self.refactoringLoading = true;
            let claimsFetch = self.$store.dispatch('applications/getApplicationRefactorings',  {id: self.id, page:self.selectedReactoringsPage, rowCount: self.refactoringsRowsPerPage, pagination: self.refactoringsPagination, sort: self.refactoringSorting });
            claimsFetch.then(response =>
                    {
                      self.showRefactorings = response.RowCount !== 0;
                      self.processRefactoringsData(response);
                      self.refactoringLoading = false;
                    }, () =>
                    {
                      // error
                      self.refactoringLoading = false;
                    }
            );
          },
          processClaimsData (obj)
          {
            let self = this;

            let claims = obj.Rows;
            self.claims = [];

            for (let claim of claims)
            {
              let claimClient = {
                id: claim.Id,
                Account: claim.Account,
                Capital: claim.Capital,
                Created: claim.Created,
                DebtorName: claim.DebtorName,
                DebtorRegistryId: claim.DebtorRegistryId,
                DueDate: claim.DueDate,
                FactoringDueDate: claim.FactoringDueDate,
                FeeAmount: claim.FeeAmount,
                InitialTransferAmount: claim.InitialTransferAmount,
                LastPaymentDate: claim.LastPaymentDate,
                LeftToPay: claim.LeftToPay,
                Status: claim.Status,
                Buffer: claim.Buffer
              };
              self.claims.push(claimClient);
            }
            self.claimRowCount = obj.RowCount;
          },
          processRefactoringsData (obj)
          {
            let self = this;

            let refactorings = obj.Rows;
            self.refactorings = [];

            for (let refactoring of refactorings)
            {
              let refactoringClient = {
                Id: refactoring.Id,
                DebtorName: refactoring.DebtorName,
                DebtorRegistryId: refactoring.DebtorRegistryId,
                FactoringDueDate: refactoring.FactoringDueDate,
                UsedForRefactoring: refactoring.UsedForRefactoring,
                RefactoringPaymentDate: refactoring.RefactoringPaymentDate
              };
              self.refactorings.push(refactoringClient);
            }
            self.refactoringRowCount = obj.RowCount;
          },
          refreshApplicationData ()
          {
            let self = this;

            let appFetch = self.$store.dispatch('applications/getApplicationDetail', {id: self.id})
            appFetch.then(response =>
            {
              // self.processApplicationData(response)
              self.applicationData = response;

            }, () =>
            {
              //  error
            })
          },
          approveApplicationOffer ()
          {
            let self = this;

            self.processingApproveApplicationRequest = true;
            self.$store.dispatch('applications/approveApplication', {id: self.id}).then(response =>
            {
              self.$store.commit('notification/showNotificationInternal', {type:'info', msg: 'krita.notification.approveapplicationoffer'});
              self.processingApproveApplicationRequest = false;
              self.refreshPage();
            }, () =>
            {
              //  error
              self.$store.commit('notification/showNotificationInternal', {type:'error', msg: 'krita.notification.error.approveapplicationoffer'});
              self.processingApproveApplicationRequest = false;
            })
          },
          cancelApplicationOffer ()
          {
            let self = this;

            self.processingCancelApplicationRequest = true;
            self.$store.dispatch('applications/cancelApplication', {id: self.id}).then(response =>
            {
              self.$store.commit('notification/showNotificationInternal', {type:'info', msg: 'krita.notification.cancelapplicationoffer'});
              self.processingCancelApplicationRequest = false;
              self.refreshPage();
            }, () =>
            {
              //  error
              self.$store.commit('notification/showNotificationInternal', {type:'error', msg: 'krita.notification.error.cancelapplicationoffer'});
              self.processingCancelApplicationRequest = false;
            })
          },
          removesFactoringFromApplication (factoringId)
          {
            let self = this;

            self.processingRemoveClaimFromApplicationRequest = true;
            self.$store.dispatch('applications/removesFactoringFromApplication', {applicationId: self.id, factoringId: factoringId}).then(response =>
            {
              self.$store.commit('notification/showNotificationInternal', {type:'info', msg: 'krita.notification.removesfactoringfromapplication'});
              self.processingRemoveClaimFromApplicationRequest = false;
              self.refreshPage();
            }, () =>
            {
              //  error
              self.$store.commit('notification/showNotificationInternal', {type:'error', msg: 'krita.notification.error.removesfactoringfromapplication'});
              self.processingRemoveClaimFromApplicationRequest = false;
              self.refreshPage();
            })
          },
          refreshPage ()
          {
            let self = this;

            self.refreshClaimsData();
            self.refreshApplicationData();
            self.refreshRefactoringsData ();
          },
          navigateToFactoringDetail (id)
          {
            let self = this;

            self.$router.push('/factoring/' + id);
          }
          // processApplicationData (obj)
          // {
          //   let self = this;
          //
          // }
        },
	}
</script>

<style lang="css" scoped>
.btn {
  width:100px;
  max-width:100px;
}
.pseudolink {
  color:blue;
  cursor:pointer;
}
</style>
